module.exports = __webpack_public_path__ + "images/landing_mgp_pandora.b8ba390bfa65b5d88a416ca403abf8e5.jpg";